import { render, staticRenderFns } from "./white-papers-page.vue?vue&type=template&id=f3934e18&scoped=true"
import script from "./white-papers-page.vue?vue&type=script&lang=js"
export * from "./white-papers-page.vue?vue&type=script&lang=js"
import style0 from "./white-papers-page.vue?vue&type=style&index=0&id=f3934e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3934e18",
  null
  
)

export default component.exports